import React, {Component} from 'react';

import ToggleInput from "../../../../components/ToggleInput/toggleInput";

export default class AreaView extends Component {

    render() {

        let area = this.props.item;
        if(!area){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{area.name}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Código</label>
                        <p className={"field-p"}>{area.code}</p>
                    </div>
                    <div className={"col s12 input-field"}>
                        <ToggleInput
                            selected={area.active}
                            name={'¿Área activa?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(area, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/AreaView.js